<template>
  <div id="footer" class="container-fluid">
    <p class="title">{{ config.name }}</p>
    <div class="info">
      <div class="left">
        <p class="address_tel">
          <span>地址：{{ config.address }}</span>
        </p>
        <p class="email_wx">
          <span>工作时间：周一至周五 09:00-18:00</span>
        </p>
        <p class="address_tel">
          <span>联系电话：{{ config.tel }}</span>
        </p>
        <p class="email_wx">
          <span>邮箱：{{ config.email }}</span>
        </p>
        <!-- <p class="email_wx">
          <span>公司微信号：{{ config.wechat }}</span>
        </p> -->
      </div>
      <div class="right">
        <p class="code_info">汇码付APP下载码，欢迎下载体验</p>
        <!-- <p class="code_info">欢迎扫码下载体验汇码付APP</p> -->
        <img class="qr_code" src="../assets/img/汇码付APP下载码.png" alt="">
      </div>
    </div>

    <p class="copy">Copyright &copy; 2020 - 2022 {{ config.keepOnRecordIcp }} {{ config.name }}</p>
  </div>
</template>
<script>
import config from '@/config'
export default {
  name: "Footer",
  data() {
    return {
      config: config
    };
  }
};
</script>
<style scoped>
#footer {
  /* position: fixed; */
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
  padding: 30px 0 0;
}

.title {
  font-size: 25px;
  margin-bottom: 20px;
}

.info {
  display: flex;
  justify-content: center;

  .left {
    margin-right: 20px;
    text-align: center;
  }

  .right {
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .code_info {
      color: #d3d3d3;
      font-size: 14px;
      /* margin: 10px 0; */
    }

    .qr_code {
      width: 100px;
    }
  }
}

.address_tel {
  color: #d3d3d3;
  font-size: 14px;
}

.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}

.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin-top: 26px;
}

@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }

  .info {
    display: flex;
    justify-content: center;

    .left {
      margin-right: 6px;

      .address_tel {
        font-size: 12px;
      }

      .email_wx {
        font-size: 12px;
      }
    }

    .right {
      margin-left: 6px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .code_info {
        color: #d3d3d3;
        font-size: 12px;
      }

      .qr_code {
        width: 86px;
      }
    }
  }

  .copy {
    font-size: 12px;
    margin: 30px 0 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue